import script from "./HomeWhyComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeWhyComponent.vue?vue&type=script&setup=true&lang=js"

import "./HomeWhyComponent.vue?vue&type=style&index=0&id=385308c8&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-morula\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-385308c8"]])

export default __exports__